/**
 * @remix-run/server-runtime v1.0.5
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var data = require('./data.js');

async function createRouteData(matches, responses) {
  let data$1 = await Promise.all(responses.map(data.extractData));
  return matches.reduce((memo, match, index) => {
    memo[match.route.id] = data$1[index];
    return memo;
  }, {});
}
async function createActionData(response) {
  return data.extractData(response);
}

exports.createActionData = createActionData;
exports.createRouteData = createRouteData;
